function sortKeys(shades) {
  return shades.sort((a, b) => Number(a) - Number(b));
}
function generateColorScheme({
  palettes,
  count
}) {
  const result = [];
  const colorGroups = palettes.map((palette) => {
    if (!palette) return [];
    const shades = sortKeys(Object.keys(palette));
    const mid = Math.floor(shades.length / 2);
    const centered = [...shades.slice(mid), ...shades.slice(0, mid).reverse()];
    return centered.map((shade) => palette[shade]);
  });
  let index = 0;
  while (result.length < count) {
    const group = colorGroups[index % colorGroups.length];
    const pickIndex = Math.floor(result.length / colorGroups.length);
    if (group?.[pickIndex]) {
      result.push(group[pickIndex]);
    }
    index++;
    if (index > 50) break;
  }
  return result;
}
const getSingleColorWithGradient = (palette) => ({
  top: palette[900],
  bottom: palette[100],
  border: palette[400],
  color: palette[600]
});
export {
  generateColorScheme,
  getSingleColorWithGradient
};
